module.exports = __webpack_public_path__ + "static/img/s13.5cc06bf9.png";